import styled from '@emotion/styled';

import {mixinFocus} from '@ELib/styles/mixins';

export const StyledList = styled.ul`
  height: 100%;
  margin-top: 0;
  margin-bottom: 0;
  padding: 0 0 1px 0; /* Needed to trigger LoadTrigger */
  color: var(--color-core-link);
  font-weight: var(--list-font-weight-text);
  overflow-y: scroll;
  overflow-y: overlay;

  li {
    display: block;
    position: relative;

    &.selected {
      background: var(--color-state-selected);
      color: var(--color-core-black);
    }

    &.active {
      background-color: var(--color-state-active);
      color: var(--color-core-black);
      .EIconButton {
        svg {
          fill: var(--color-core-black);
        }
      }
    }

    &.disabled {
      pointer-events: none;
    }

    &.expanded:not(.active) {
      background-color: var(--color-state-grouping);
    }

    &.expanded > ul {
      background-color: var(--list-subitem-bg-color);
    }

    & > ul {
      padding: 0;
    }

    &:not(.noHover):hover {
      background-color: var(--color-state-hover);
      color: var(--color-core-black);

      .EIconButton {
        svg {
          fill: var(--color-core-black);
        }

        &:hover {
          svg {
            fill: var(--color-core-white);
          }
        }
      }
    }

    .styleDragged {
      opacity: var(--element-drag-opacity);
      cursor: grabbing;
      background: var(--color-state-active);

      & > div[role='button'],
      button {
        cursor: grabbing;
      }
    }

    &.sticky {
      position: sticky;
      top: 0;
      z-index: var(--zindex-sticky-header);
    }
  }

  li.placeholder {
    font-weight: var(--placeholder-font-weight);
    background-color: var(--placeholder-bg-color);
    color: var(--color-core-black);
    text-align: center;
    padding: var(--gutter);
  }

  .MuiListItemButton-root {
    background-color: unset;
  }

  .Mui-focusVisible {
    &&&& {
      background-color: unset;
    }
    ${mixinFocus}
  }
`;
